export function initTransitions($) {
    $(".gb-grid-wrapper").each(function (n, wrap) {
        var kids = $("> .gb-grid-column", wrap).length;

        if (kids != 2) {
            $("> .gb-grid-column", wrap).each(function (n, item) {
                $(item)
                    .attr("data-aos", "fade-up")
                    .attr("data-aos-delay", 300 * n);
            });
        } else {
            $("> .gb-grid-column:nth-child(1)", wrap).attr("data-aos", "fade-right");
            $("> .gb-grid-column:nth-child(2)", wrap).attr("data-aos", "fade-left").attr("data-aos-delay", 400);
        }
    });

    $(".section-title").each(function (n, wrap) {
        $(wrap).attr("data-aos", "fade-up");
    });

    // $(".carousel3d").each(function (n, wrap) {
    //     $(wrap).attr("data-aos", "zoom-in");
    // });

    // $(".news-listing-grid").each(function (n, wrap) {
    //     $(wrap).attr("data-aos", "fade-up");
    // });

	// news
    $(".latest-news").each(function (n, wrap) {
        $(".latest-news-image-wrapper", wrap)
			.attr("data-aos", "fade-right");
		$(".latest-news-entry-wrapper", wrap)
			.attr("data-aos", "fade-left");

		$('.col-12.mt-8 .news-entry-link', wrap).each(function (n, item) {
			$(item).attr("data-aos", "fade-up")
				 .attr("data-aos-delay", 400 * n);
		});
    });

	// cover block
    $(".wp-block-cover").each(function (n, wrap) {
        $("> .wp-block-cover__inner-container", wrap).each(function (n, item) {
            $(item).attr("data-aos", "fade-left");
        });
    });

	// quotes
    $(".wp-block-pullquote, .wp-block-quote").each(function (n, wrap) {
        $(wrap).attr("data-aos", "fade-up");
    });

	// blocks
    $(".wp-block-embed, .wp-block-table, .gform_wrapper").each(function (n, wrap) {
        $(wrap).attr("data-aos", "fade-up");
    });

	// buttons
    $(".wp-block-buttons").each(function (n, wrap) {
        $(".wp-block-button", wrap).each(function (n, item) {
			var transition = $(item).hasClass('is-style-arrow') ? 'fade-up' : 'flip-left';

            $(item)
                .attr("data-aos", transition)
                .attr("data-aos-delay", 400 * n);
        });
    });

	// page header
    $(".entry-header").each(function (n, wrap) {
        $(".entry-header-wrapper", wrap).each(function (n, item) {
            $(item)
                .attr("data-aos", "fade-left")
                .attr("data-aos-delay", 400 * n);
        });
    });

    $(".offset-heading-block").each(function (n, wrap) {
        $('.line1', wrap)
            .attr("data-aos", "fade-right");
        $('.line2', wrap)
            .attr("data-aos", "fade-left")
			.attr("data-aos-delay", 250 * n);
        $('.line3', wrap)
            .attr("data-aos", "fade-right")
			.attr("data-aos-delay", 250 * n);
    });

    $(".slider-offset-text").each(function (n, wrap) {
		$('.slide-content1', wrap)
			.attr("data-aos", "fade-right");

		$('.slide-title', wrap)
			.attr("data-aos", "fade-down")
			.attr("data-aos-delay", 400 * n);

		$('.slide-text', wrap)
			.attr("data-aos", "fade-up")
			.attr("data-aos-delay", 400 * n);
    });

    $(".featured-content").each(function (n, wrap) {
        $(".col-md-6", wrap).each(function (n, item) {
            $(item)
                .attr("data-aos", "flip-left")
                .attr("data-aos-delay", 400 * n);
        });
    });

    $(".footer-ctas").each(function (n, wrap) {
        $(".footer-cta", wrap).each(function (n, item) {
            $(item)
                .attr("data-aos", "flip-left")
                .attr("data-aos-delay", 400 * n);
        });
    });

    $(".child-pages").each(function (n, wrap) {
        $(".child-pages-card", wrap).each(function (n, item) {
            $(item)
                .attr("data-aos", "fade-up")
                .attr("data-aos-delay", 400 * n);
        });
    });
}
